export default theme => ({
  root: {
    margin: '16px 0'
  },
  policy: {
    display: 'inline-block',
    width: '50%',
    padding: '8px 0 4px 8px',
    boxSizing: 'border-box',
    '&::before': {
      position: 'relative',
      content: '"\\25CF"',
      top: -1,
      left: -4,
      speak: 'none'
    }
  },
  on: {
    opacity: 0.5,
    '&::before': {
      color: theme.colors.utility.textPrimary
    }
  },
  off: {
    '&::before': {
      color: theme.colors.actionMajor[500]
    }
  }
});